export default "__VITE_PUBLIC_ASSET__30481bce__"